<template>
  <div class="order-create">
    <iframe
      :src="iframeSrc"
      frameborder="0"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
import {useRoute} from 'vue-router'
import {computed} from 'vue'

export default {
  name: 'OrderCreate',
  setup() {
    const route = useRoute()

    const iframeSrc = computed(() => {
      const url = new URL('https://calc.apex-tech.ru/iframe/order/create/?color=%23e42c31&location_dispatch=ebcb9168-70a1-11ed-ae68-ac1f6b447939')
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
iframe {
  height: calc(100vh - 92px);
  max-width: 100%;
  width: 100%;
}
@media screen and (max-width: 768px) {
  iframe {
    height: calc(100vh - 80px);
  }
}
</style>
